import { useState } from "react";
import { Box, Tabs, Tab, TextField } from "@mui/material";

const CustomerTabs = ({ onFilterChange }) => {
  const [value, setValue] = useState("all");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const handleChange = (event, newValue) => {
    try {
      if (newValue === "all") {
        setFromDate("");
        setToDate("");
        onFilterChange?.({ type: "all" });
      } else if (newValue === "today") {
        setFromDate("");
        setToDate("");
        onFilterChange?.({ type: "today" });
      } else if (newValue === "month") {
        setFromDate("");
        setToDate("");
        onFilterChange?.({ type: "month" });
      } else if (newValue === "custom") {
        onFilterChange?.({
          type: "custom",
          fromDate: fromDate || null,
          toDate: toDate || null,
        });
      }
    } catch {
    } finally {
    }
    setValue(newValue);
  };

  const handleDateChange = (field, value) => {
    if (field === "from") {
      setFromDate(value);
      const next = { type: "custom", fromDate: value || null, toDate };
      onFilterChange?.(next);
    } else {
      setToDate(value);
      const next = { type: "custom", fromDate, toDate: value || null };
      onFilterChange?.(next);
    }
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="All" value="all" />
        <Tab label="New Customers" value="today" />
        <Tab label="Customers Within a Month" value="month" />
        <Tab label="Custom" value="custom" />
      </Tabs>

      {value === "custom" && (
        <Box
          sx={{
            mt: 1,
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <TextField
            label="From"
            type="date"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={fromDate}
            onChange={(e) => handleDateChange("from", e.target.value)}
          />
          <TextField
            label="To"
            type="date"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={toDate}
            onChange={(e) => handleDateChange("to", e.target.value)}
          />
        </Box>
      )}
    </Box>
  );
};

export default CustomerTabs;
